/**
 * Matcher for query
 * @module
 */
var _ = require('optimizely-client-fn');
var match = require('core/lib/match');

exports.fieldsNeeded = ['queryParams'];

exports.match = function(value, cond) {
  var queryParamValue = _.find(value.queryParams, function(eachQueryParam) {
    return eachQueryParam[0] === cond.name;
  });
  return match.hasMatch(cond.value, cond.match, queryParamValue ? queryParamValue[1] : null);
};
